import * as React from 'react';

const css = require('./index.scss');

export interface IIconProps {
    elId: string;
    children?: any;
    className?: string;
}

export default function PrintingButton(props: IIconProps) {

    const classNameHandle = () => {
        return props.className ? `${css.btn} ${props.className}` : css.btn;
    };

    const clickHandler = () => {
        var el = document.getElementById(props.elId);
        
        if (!el){
            return;
        }
        el.setAttribute("marginwidth", "0");
        el.setAttribute("border", "0");
        el.setAttribute("marginheight", "0");
        el.setAttribute('style', 'padding:0px;margin:0px;');
        // var doc = null;
        // let iframe=document.getElementById("print-iframe");
        // if(!iframe){  
        //     iframe = document.createElement('iframe');
        //     iframe.setAttribute("id", "print-iframe");
        //     iframe.setAttribute("marginwidth", "0");
        //     iframe.setAttribute("border", "0");
        //     iframe.setAttribute("marginheight", "0");
        //     iframe.setAttribute('style', 'position:fixed;width:0px;height:0px;left:-500px;top:-500px;padding:0px;margin:0px;');
        //     document.body.appendChild(iframe);        
        // }
        // doc = (iframe as any).contentWindow.document;
        // doc.write('<div>' + el.innerHTML + '</div>');
        // doc.close();
        (el as any).contentWindow.focus();  
        (el as any).contentWindow.print();
        if (navigator.userAgent.indexOf("MSIE") > 0){
            document.body.removeChild(el);
        }
    };
    return (
        <div className={classNameHandle()} onClick={clickHandler}>
            {props.children}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/PreviewPublic/Components/PrintingButton/index.tsx